import ReactCodeInputComponent from 'react-code-input';
import styled from 'styled-components';
import { Button } from 'components/Button';
import { isMobile } from 'utils';

export const ResendHint = styled.div`
  display: flex;
  gap: 8px;
  margin: 0 auto 16px;
`;

export const Counter = styled.div`
  color: var(--v3-text-color);
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
`;

export const OtpWrapper = styled.div`
  gap: 8px;
`;

export const OtpWrapperHeading = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;

export const ReactCodeInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24vh;
`;

export const TerminalVerifyWithOtpCodeError = styled.div`
  text-align: right;
  width: 100%;
  color: var(--v3-error-color);
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 10px;
  padding-right: 5%;
`;

export const ReactCodeInput = styled(ReactCodeInputComponent)`
  display: flex !important;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: ${isMobile() ? '80' : '30'}vw;
  gap: 8px;

  & input {
    padding: 0 !important;
  }
`;

export const ModalWrapper = styled.div`
  background-color: var(--v3-black-0);
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: ${isMobile() ? '100' : '37'}vw;
`;

export const Title = styled.div`
  font-weight: 800;
  font-size: ${isMobile() ? '18' : '24'}px;
  line-height: 30px;
  color: var(--v3-text-color);
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 5px;
`;
export const Border = styled.div`
  border: 0.5px solid var(--v3-black-4);
  margin: 20px 0px;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 100%;
  white-space: pre-wrap;
  color: var(--v3-black-100);

  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: 15px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin: 0 8px 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const ButtonContainer = styled.div`
  flex: 1 1 0;
`;

export const ConfirmationButton = styled(Button)`
  &&& {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 48px;
    overflow: initial;
  }
`;
